// This should be moved to lib somewhere
// 'context' needs to be in a shared location as both libs and apps need to reference it
import { createContext } from '../context/context-key.js';
export const configContext = createContext('config');
//# sourceMappingURL=config.js.map